// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nk-0";